import { ThunkDispatch } from '@reduxjs/toolkit';
import { FormikProps } from 'formik';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { Action } from 'redux';
import { RootState } from 'slices';
import {
  setShowAllValidateErrors,
  setCountSubmit,
  resetProductOption,
} from 'slices/productOption/reducer';
import { ProductOptionFormType } from 'types/product/productOptionTypes';
import { PRODUCT_OPTIOINS_LIMIT } from '../ProductOptionConstants';

const FormActionButtons = ({
  dispatch,
  formik,
  NameExists,
  FormErrorCount,
  reachCreateLimit,
}: {
  dispatch: ThunkDispatch<RootState, void, Action>;
  formik: FormikProps<ProductOptionFormType>;
  NameExists?: boolean;
  FormErrorCount?: number;
  reachCreateLimit?: boolean;
}) => {
  const history = useNavigate();
  return (
    <Row>
      <Col xs={12} sm={6} className="text-center">
        <div className="mb-3">
          <Row>
            <Col xs={1} sm={3}></Col>
            <Col xs={5} sm={3}>
              <Button
                block
                outline
                color="dark"
                className="btn btn-ghost-light material-shadow-none"
                id="product-add-on-cancel"
                type="button"
                onClick={() => {
                  dispatch(setShowAllValidateErrors(false));
                  dispatch(resetProductOption());
                  history('/product-option');
                }}
              >
                {t('Btn_Cancel')}
              </Button>
            </Col>

            <Col xs={5} sm={3}>
              <Button
                block
                color="success"
                type="submit"
                id="product-add-on-save"
                disabled={
                  NameExists ||
                  FormErrorCount !== 0 ||
                  formik.isSubmitting ||
                  reachCreateLimit
                }
                // disabled={formik.isSubmitting}
                onClick={async () => {
                  await formik.setTouched(
                    Object.keys(formik.initialValues).reduce(
                      (acc, key) => ({ ...acc, [key]: true }),
                      {}
                    )
                  );
                  dispatch(setShowAllValidateErrors(true));
                  dispatch(setCountSubmit());
                }}
              >
                {t('Btn_Save')}
              </Button>
              {reachCreateLimit && (
                <div className="text-danger mt-1">
                  {t('Create up to {{item}} items', {
                    item: PRODUCT_OPTIOINS_LIMIT,
                  })}
                </div>
              )}
            </Col>
            <Col xs={1} sm={3}></Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FormActionButtons;
